// Content + assets for the Jadoo Ki Jhappy homepage.
// Numeric placeholders are intentionally editable per client request.

export const LOGO_URL =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_human-connection-hub/artifacts/62esv3fq_Final-Logo-JKJ.webp";

// Real brand photography (Jadoo Ki Jhappy / Nupur Pittie) supplied by client.
export const REAL = {
  heroWorkshop: "https://customer-assets-m6fa6gv7.emergentagent.net/job_human-connection-hub/artifacts/zrzxidr3_IMG_2891.webp",
  nupurSpeaker: "https://customer-assets-m6fa6gv7.emergentagent.net/job_human-connection-hub/artifacts/3wrdutlf_0X9A0209.webp",
  crowdSelfie: "https://customer-assets-m6fa6gv7.emergentagent.net/job_human-connection-hub/artifacts/rrgevd4w_IMG_5809.webp",
  anandHandshake: "https://customer-assets-m6fa6gv7.emergentagent.net/job_human-connection-hub/artifacts/sngclagq_0X9A0262.webp",
};

export const IMAGES = {
  hero: REAL.heroWorkshop,
  nupur: REAL.nupurSpeaker,
  breathwork: "https://images.pexels.com/photos/6014734/pexels-photo-6014734.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  iceBath: "https://images.unsplash.com/photo-1619284661713-89777e4886a4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwzfHxpY2UlMjB3YXRlciUyMHR1YiUyMHdlbGxuZXNzfGVufDB8fHx8MTc4NjE0MzM3NHww&ixlib=rb-4.1.0&q=85",
  firewalk: "https://images.unsplash.com/photo-1569430251091-da3b108cff29?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwxfHxib25maXJlJTIwcGVvcGxlJTIwbmlnaHR8ZW58MHx8fHwxNzg2MTQzMzc0fDA&ixlib=rb-4.1.0&q=85",
  teamBuilding: "https://images.unsplash.com/photo-1780733066784-64ae88196345?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHx0ZWFtJTIwYnVpbGRpbmclMjBvdXRkb29yJTIwZ3JvdXB8ZW58MHx8fHwxNzg2MTQzMzc0fDA&ixlib=rb-4.1.0&q=85",
  soundHealing: "https://images.unsplash.com/photo-1593810451410-8fbb422cc15e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxtZWRpdGF0aW9uJTIwc291bmQlMjBoZWFsaW5nJTIwYm93bHMlMjBjYWxtfGVufDB8fHx8MTc4NjE0MzUxMHww&ixlib=rb-4.1.0&q=85",
  yoga: "https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTB8MHwxfHNlYXJjaHwxfHx5b2dhJTIwd2VsbG5lc3MlMjBuYXR1cmFsJTIwcmV0cmVhdHxlbnwwfHx8fDE3ODYxNDM1MTB8MA&ixlib=rb-4.1.0&q=85",
  inclusion: "https://images.unsplash.com/photo-1582213782179-e0d53f98f2ca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzl8MHwxfHNlYXJjaHwxfHxkaXZlcnNlJTIwdGVhbSUyMGNlbGVicmF0aW9uJTIwaW5jbHVzaW9uJTIwaGFuZHMlMjB0b2dldGhlcnxlbnwwfHx8fDE3ODYxNDM1MTB8MA&ixlib=rb-4.1.0&q=85",
  medicineFree: "https://images.unsplash.com/photo-1590779033100-9f60a05a013d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwyfHxoZWFsdGh5JTIwZnJlc2glMjB2ZWdldGFibGVzJTIwbmF0dXJhbCUyMGZvb2R8ZW58MHx8fHwxNzg2MTQzNTEwfDA&ixlib=rb-4.1.0&q=85",
  innerChild: "https://images.unsplash.com/photo-1523956468692-1e219561ea46?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1Nzl8MHwxfHNlYXJjaHwxfHxxdWlldCUyMHJlZmxlY3Rpb24lMjBwZXJzb24lMjBwZWFjZWZ1bCUyMHdpbmRvdyUyMGxpZ2h0fGVufDB8fHx8MTc4NjE0MzUxMHww&ixlib=rb-4.1.0&q=85",
};

export const CREDIBILITY = [
  { value: "20+", label: "Years Experience" },
  { value: "500+", label: "Programs" },
  { value: "Guinness", label: "World Record" },
];

// Section 3 — Impact. Placeholders kept editable per client request.
export const IMPACT_STATS = [
  { value: "20+", label: "Years of Experience", animate: true, to: 20 },
  { value: "500+", label: "Programs Conducted", animate: true, to: 500 },
  { value: "10000+", label: "People Impacted", animate: true, to: 10000 },
  { value: "700+", label: "Organizations & Institutions", animate: true, to: 700 },
];

export const WHY_CARDS = [
  {
    n: "01",
    title: "Employee Burnout",
    desc: "Always-on cultures quietly drain energy. We help teams recover, recharge and rebuild sustainable performance.",
  },
  {
    n: "02",
    title: "Emotional Wellbeing",
    desc: "Beneath every KPI is a human being. We create safe spaces for people to process, heal and feel whole again.",
  },
  {
    n: "03",
    title: "Team Connection",
    desc: "Hybrid work erodes belonging. Our experiences rebuild trust, empathy and genuine human bonds across teams.",
  },
  {
    n: "04",
    title: "Leadership Pressure",
    desc: "Leaders carry invisible weight. We equip them to lead with resilience, clarity and emotional intelligence.",
  },
  {
    n: "05",
    title: "Workplace Stress",
    desc: "Chronic stress compounds silently. We introduce practical, science-backed tools people actually use.",
  },
  {
    n: "06",
    title: "Employee Engagement",
    desc: "Engagement is felt, not forced. We spark participation, energy and pride that outlasts the workshop.",
  },
];

export const SOLUTIONS = [
  {
    id: "emotional-wellbeing",
    index: "01",
    title: "Emotional Wellbeing",
    desc: "Deep inner work that helps people process emotion, release stress and reconnect with themselves.",
    image: IMAGES.soundHealing,
    programs: ["Inner Child Healing", "Meditation", "Breathwork", "Sound Healing", "Art Therapy", "Bio Decoding"],
  },
  {
    id: "preventive-health",
    index: "02",
    title: "Preventive Health & Wellness",
    desc: "Practical, medicine-free practices that build lasting physical vitality and everyday resilience.",
    image: IMAGES.yoga,
    programs: ["Medicine-Free Life", "Naturopathy", "Yoga", "Acupressure", "Mudra Healing", "Pranic Healing"],
  },
  {
    id: "team-leadership",
    index: "03",
    title: "Team & Leadership Experiences",
    desc: "High-energy, experiential challenges that forge trust, courage and collective momentum.",
    image: IMAGES.teamBuilding,
    programs: ["Team Building", "Firewalk Experience", "Ice Bath Experience", "Dance & Movement Therapy", "Laughter & Hug Therapy"],
  },
  {
    id: "culture-inclusion",
    index: "04",
    title: "Culture & Inclusion",
    desc: "Thoughtful sensitisation that builds workplaces where every person feels seen, safe and valued.",
    image: IMAGES.inclusion,
    programs: ["LGBTQ+ Sensitisation"],
  },
];

export const FEATURED = [
  {
    name: "Inner Child Healing",
    desc: "A guided journey to release old emotional patterns and rediscover playfulness and self-compassion.",
    duration: "Half / Full Day",
    image: IMAGES.innerChild,
    tag: "Emotional Wellbeing",
  },
  {
    name: "Team Building",
    desc: "Immersive challenges engineered to rebuild trust, communication and collective momentum.",
    duration: "Half / Full Day",
    image: IMAGES.teamBuilding,
    tag: "Team & Leadership",
  },
  {
    name: "Firewalk Experience",
    desc: "A transformational walk over hot coals that dissolves fear and unlocks unstoppable belief.",
    duration: "2–3 Hours",
    image: IMAGES.firewalk,
    tag: "Breakthrough",
  },
  {
    name: "Ice Bath Experience",
    desc: "Controlled cold exposure that trains composure, focus and calm under pressure.",
    duration: "60–90 Mins",
    image: IMAGES.iceBath,
    tag: "Resilience",
  },
  {
    name: "Medicine-Free Life",
    desc: "A preventive-health masterclass on nutrition and natural living for sustained energy.",
    duration: "Workshop Series",
    image: IMAGES.medicineFree,
    tag: "Preventive Health",
  },
  {
    name: "Breathwork",
    desc: "Guided breathing techniques that regulate the nervous system and restore clarity.",
    duration: "60–90 Mins",
    image: IMAGES.breathwork,
    tag: "Emotional Wellbeing",
  },
];

// Content + imagery for the Meditation & Mindfulness program (also used as the
// shared template body for all Corporate Wellbeing programs until real content
// is supplied). Images are placeholders — swap the URLs below with real photos.
export const MEDITATION = {
  slug: "meditation-and-mindfulness",
  category: "Corporate Wellbeing",
  title: "Meditation & Mindfulness",
  subtitle:
    "Evidence-based mindfulness sessions that help teams switch off the noise, sharpen focus and perform with a calmer, clearer mind.",
  images: {
    hero: "https://images.unsplash.com/photo-1529693662653-9d480530a697?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwyfHxjb3Jwb3JhdGUlMjBlbXBsb3llZXMlMjBncm91cCUyMG1lZGl0YXRpb24lMjBvZmZpY2UlMjB3ZWxsbmVzc3xlbnwwfHx8fDE3ODc4MjY4NTR8MA&ixlib=rb-4.1.0&q=85",
    space: "https://images.unsplash.com/photo-1643682661119-28da0685be2c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NjZ8MHwxfHNlYXJjaHwxfHxjb3Jwb3JhdGUlMjBlbXBsb3llZXMlMjBncm91cCUyMG1lZGl0YXRpb24lMjBvZmZpY2UlMjB3ZWxsbmVzc3xlbnwwfHx8fDE3ODc4MjY4NTR8MA&ixlib=rb-4.1.0&q=85",
    detail: "https://images.unsplash.com/photo-1528319725582-ddc096101511?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxtaW5kZnVsJTIwaGFuZHMlMjBsYXAlMjBtZWRpdGF0aW9uJTIwcG9zdHVyZSUyMGRldGFpbHxlbnwwfHx8fDE3ODc4MjY4NTR8MA&ixlib=rb-4.1.0&q=85",
    calm: "https://images.unsplash.com/photo-1687477849315-319f71839f2f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxjYWxtJTIwd29tYW4lMjBleWVzJTIwY2xvc2VkJTIwYnJlYXRoaW5nJTIwc2VyZW5lfGVufDB8fHx8MTc4NzgyNjg1NHww&ixlib=rb-4.1.0&q=85",
  },
  facts: [
    { label: "Format", value: "In-person or Virtual" },
    { label: "Duration", value: "60 mins – Full day" },
    { label: "Group Size", value: "10 – 500+ people" },
    { label: "Experience", value: "No prior practice needed" },
  ],
  overview: [
    "In always-on workplaces, attention is the scarcest resource. Our Meditation & Mindfulness program gives your people practical, secular techniques to steady the mind, reduce stress and return to work with genuine focus — no jargon, no dogma.",
    "Every session is facilitated live and tailored to your context, whether it's a 60-minute reset during a wellness week or an ongoing multi-week series that builds a lasting daily practice across teams.",
  ],
  experience: [
    { title: "Guided Breath Awareness", desc: "Simple breathing techniques to down-regulate stress in minutes, usable at any desk." },
    { title: "Focused-Attention Meditation", desc: "Training the mind to concentrate, notice distraction and gently return — the core of deep work." },
    { title: "Body Scan & Relaxation", desc: "Releasing accumulated physical tension and reconnecting with the present moment." },
    { title: "Mindful Movement", desc: "Gentle, seated-friendly movement that anchors awareness in the body." },
    { title: "Loving-Kindness Practice", desc: "Cultivating empathy and warmth that strengthens team relationships." },
    { title: "Everyday Mindfulness Toolkit", desc: "Micro-practices your people can weave into meetings, commutes and email." },
  ],
  benefitsEmployees: [
    "Reduced stress, anxiety and overwhelm",
    "Sharper focus and sustained attention",
    "Better emotional regulation under pressure",
    "Improved sleep, recovery and energy",
    "Greater day-to-day resilience",
  ],
  benefitsOrgs: [
    "Lower burnout and absenteeism",
    "Higher engagement and presence",
    "Calmer, clearer decision-making",
    "Stronger empathy across teams",
    "A visible culture of wellbeing",
  ],
  formats: [
    { name: "The Taster", time: "60 minutes", desc: "A single introductory reset — perfect for town halls and wellness weeks." },
    { name: "Half-Day Immersion", time: "3 – 4 hours", desc: "A deeper hands-on workshop with a take-home practice toolkit." },
    { name: "Full-Day Retreat", time: "6 – 7 hours", desc: "An off-site day to disconnect, restore and reset as a team." },
    { name: "Ongoing Series", time: "6 – 8 weeks", desc: "Weekly guided sessions that build a durable daily habit." },
  ],
  whoFor: [
    "Leadership teams operating under sustained pressure",
    "High-stress functions — sales, support, operations",
    "Onboarding cohorts, offsites and team retreats",
    "Company-wide wellness weeks and town halls",
  ],
  quote: "The mind is like water — when it's calm, everything becomes clear.",
};

// ---- Corporate Wellbeing programs (real client content) ----
// facts, formats and images are shared placeholders — swap images with real
// photos per program later (all URLs live in one place).
const SHARED = { images: MEDITATION.images, facts: MEDITATION.facts, formats: MEDITATION.formats };

const CW_DATA = [
  {
    slug: "meditation-and-mindfulness",
    title: "Meditation & Mindfulness",
    titleLead: "Meditation &",
    accent: "Mindfulness",
    subtitle: MEDITATION.subtitle,
    images: {
      ...MEDITATION.images,
      hero: "https://customer-assets-m6fa6gv7.emergentagent.net/job_human-connection-hub/artifacts/2484flz0_Image%201.jpg",
      space: "https://customer-assets-m6fa6gv7.emergentagent.net/job_human-connection-hub/artifacts/ulbt7ptp_Image2.jpeg",
    },
    overview: MEDITATION.overview,
    techniques: ["Guided breath awareness", "Focused-attention meditation", "Body scan & relaxation", "Mindful movement", "Loving-kindness practice", "Everyday mindfulness toolkit"],
    tagline: "The mind is like water — when it's calm, everything becomes clear.",
    helps: "Helps people quiet mental noise, steady attention and regulate stress — so they return to work calmer, clearer and more focused.",
    orgImpact: MEDITATION.benefitsOrgs,
    whoFor: MEDITATION.whoFor,
  },
  {
    slug: "stress-management",
    title: "Stress Management",
    titleLead: "Stress",
    accent: "Management",
    subtitle: "A practical, interactive session that helps teams manage pressure, prevent burnout and build lasting emotional resilience.",
    images: {
      ...MEDITATION.images,
      hero: "https://customer-assets-m6fa6gv7.emergentagent.net/job_human-connection-hub/artifacts/egr8iq5u_Stess-management-1.jpg",
      space: "https://customer-assets-m6fa6gv7.emergentagent.net/job_human-connection-hub/artifacts/g2vbrjtb_Stress-Manageement-2.jpg",
    },
    overview: ["A practical, interactive session designed to help employees understand workplace stress, manage pressure effectively, prevent burnout, and build emotional resilience. Participants learn simple, actionable techniques they can use in their everyday personal and professional lives."],
    techniques: ["Deep breathing & relaxation techniques", "Mindfulness and grounding exercises", "Stress triggers & awareness mapping", "Quick desk-based stress-relief practices", "Emotional regulation techniques", "Time & priority management", "Work-life balance strategies", "Positive coping mechanisms", "Guided meditation & visualization", "Building resilience and healthy workplace habits"],
    tagline: "Manage Stress. Build Resilience. Perform at Your Best.",
    helps: "Helps individuals recognize stress triggers, regulate emotions, improve focus, manage workplace pressure, and develop healthier responses to challenging situations — supporting better mental wellbeing and sustainable performance.",
    orgImpact: ["Reduces workplace stress and risk of burnout", "Improves employee wellbeing and resilience", "Enhances focus, productivity and performance", "Supports healthier work-life balance", "Improves team communication and workplace relationships", "Boosts morale, engagement and motivation", "Contributes to a healthier, more supportive workplace culture"],
    orgNote: "Workplace wellbeing is closely connected with productivity, performance, morale and absenteeism, making stress management an important part of an effective employee wellbeing strategy.",
    whoFor: ["Employees", "Managers", "Team Leaders", "HR & L&D Teams", "Corporate Teams", "High-Pressure Professionals", "Startups", "Organizations"],
  },
  {
    slug: "laughter-and-hug-sessions",
    title: "Laughter & Hug Sessions",
    titleLead: "Laughter & Hug",
    accent: "Sessions",
    subtitle: "A fun, experiential session that uses laughter, movement and mindful connection to release stress and build a happier, more connected workplace.",
    images: {
      ...MEDITATION.images,
      hero: "https://customer-assets-m6fa6gv7.emergentagent.net/job_human-connection-hub/artifacts/eosrguhk_Laughter-Hug-1.jpg",
      space: "https://customer-assets-m6fa6gv7.emergentagent.net/job_human-connection-hub/artifacts/1rmt0fql_Laughter-Hug-2.jpg",
    },
    overview: ["A fun, experiential wellness session that uses laughter, positive interaction, movement and mindful connection to release stress and create a happier, more connected workplace. Participants experience simple techniques that support emotional wellbeing, relaxation, positive energy and team bonding."],
    techniques: ["Guided laughter exercises", "Laughter yoga techniques", "Conscious breathing", "Playful movement activities", "Positive interaction exercises", "Safe & mindful hugging practices", "Gratitude and appreciation activities", "Group connection exercises", "Mindful relaxation", "Positive energy-building activities"],
    tagline: "Laugh More. Connect Deeper. Feel Better.",
    helps: "Encourages stress relief, emotional release and positive connection while helping participants feel more relaxed, energetic and socially connected. It creates a refreshing break from routine and supports overall emotional wellbeing.",
    orgImpact: ["Reduces workplace stress and tension", "Promotes employee wellbeing and workplace happiness", "Strengthens team bonding and interpersonal connections", "Improves morale and positive workplace culture", "Encourages communication and collaboration", "Creates a more energetic and engaged workforce", "Provides employees with a refreshing mental reset"],
    whoFor: ["Employees", "Corporate Teams", "Managers", "HR & L&D Teams", "Leadership Teams", "Startups", "Schools & Colleges", "Offsites & Team-Building Programs", "Wellness Events"],
  },
  {
    slug: "medicine-free-life",
    title: "Medicine-Free Life",
    titleLead: "Medicine-Free",
    accent: "Life",
    subtitle: "A holistic session that builds healthier everyday habits through natural wellbeing, nutrition awareness, movement, rest and stress management.",
    images: {
      ...MEDITATION.images,
      hero: "https://customer-assets-m6fa6gv7.emergentagent.net/job_human-connection-hub/artifacts/viocr8nj_Medicine-Free-Life-1.jpg",
      space: "https://customer-assets-m6fa6gv7.emergentagent.net/job_human-connection-hub/artifacts/gbycah0d_Medicine-Free-Life-2.jpg",
    },
    overview: ["A holistic wellness session focused on building healthier everyday habits through natural wellbeing practices, mindful living, nutrition awareness, movement, rest and stress management. It empowers participants to understand their body better and make informed lifestyle choices that support long-term health and wellbeing."],
    techniques: ["Breathwork & mindful breathing", "Stress management techniques", "Mindfulness & meditation", "Healthy eating & nutrition awareness", "Sleep & recovery practices", "Movement and daily activity", "Natural wellness routines", "Relaxation & self-care techniques", "Hydration and lifestyle awareness", "Creating sustainable healthy habits"],
    tagline: "Heal Your Lifestyle. Strengthen Your Wellbeing. Live Better.",
    helps: "Encourages participants to become more aware of their lifestyle patterns and develop practical habits that support energy, resilience, emotional wellbeing and overall health — without relying on quick fixes.",
    orgImpact: ["Promotes a culture of preventive wellness", "Supports employee health and wellbeing", "Helps reduce stress and lifestyle-related fatigue", "Improves energy, focus and workplace vitality", "Encourages healthier daily routines", "Supports employee engagement and productivity", "Builds long-term awareness around holistic wellbeing"],
    whoFor: ["Employees", "Corporate Teams", "HR & L&D Teams", "Managers", "Leadership Teams", "High-Stress Professionals", "Startups", "Wellness Programs", "Schools & Colleges"],
  },
  {
    slug: "yoga-and-pranayama",
    title: "Yoga & Pranayama",
    titleLead: "Yoga &",
    accent: "Pranayama",
    subtitle: "A rejuvenating session combining yoga postures, pranayama and mindful movement to reduce stress, improve flexibility and enhance focus.",
    images: {
      ...MEDITATION.images,
      hero: "https://customer-assets-m6fa6gv7.emergentagent.net/job_human-connection-hub/artifacts/9knj1prs_Yoga-Pranayama-1.jpg",
      space: "https://customer-assets-m6fa6gv7.emergentagent.net/job_human-connection-hub/artifacts/8qn6attg_Yoga-Pranayama-2.jpg",
    },
    overview: ["A rejuvenating wellness session combining yoga postures, pranayama (breathing exercises) and mindful movement to help participants reduce stress, improve flexibility, enhance focus and reconnect with their body and breath. Designed to bring greater balance, relaxation and energy into everyday life."],
    techniques: ["Basic yoga asanas & mindful movement", "Pranayama and breathwork", "Deep breathing exercises", "Stretching & mobility practices", "Mindful body awareness", "Relaxation techniques", "Guided meditation", "Posture & alignment awareness", "Stress-relieving breathing practices", "Short desk-friendly yoga techniques"],
    tagline: "Breathe Better. Move Better. Live Better.",
    helps: "Helps participants release physical tension, calm the mind, improve flexibility and mobility, enhance concentration and develop healthier breathing and relaxation habits.",
    orgImpact: ["Reduces workplace stress and physical tension", "Supports employee wellbeing and mental relaxation", "Improves focus, energy and concentration", "Encourages healthier workplace habits", "Supports flexibility, mobility and posture", "Enhances employee engagement and workplace wellness", "Creates a calmer, more balanced work environment"],
    whoFor: ["Employees", "Corporate Teams", "HR & L&D Teams", "Managers", "Leadership Teams", "Startups", "Schools & Colleges", "Wellness Programs", "Corporate Offsites", "Workplace Wellness Events"],
  },
  {
    slug: "art-therapy",
    title: "Art Therapy",
    titleLead: "Art",
    accent: "Therapy",
    subtitle: "A creative, experiential session using art, colours and self-expression as tools for relaxation, mindfulness and emotional wellbeing.",
    images: {
      ...MEDITATION.images,
      hero: "https://customer-assets-m6fa6gv7.emergentagent.net/job_human-connection-hub/artifacts/f1tuiyek_Art-Therapy-1.jpg",
      space: "https://customer-assets-m6fa6gv7.emergentagent.net/job_human-connection-hub/artifacts/ja0u5tga_Art-therapy-2.jpg",
    },
    overview: ["A creative and experiential wellness session that uses art, colours and self-expression as tools for relaxation, mindfulness and emotional wellbeing. Participants explore their creativity through simple, engaging activities designed to encourage self-expression, reduce stress and create a refreshing mental reset."],
    techniques: ["Guided creative expression", "Colour-based activities", "Mandala & mindful art", "Doodling and intuitive drawing", "Art-based relaxation exercises", "Emotional expression through colours", "Collaborative team art activities", "Mindfulness through creativity", "Vision boards & positive visualization", "Reflective art exercises"],
    tagline: "Create. Express. Unwind.",
    helps: "Encourages creative self-expression, mindfulness and relaxation while providing a non-verbal way to explore thoughts and emotions. It offers participants a refreshing break from routine and supports stress relief and emotional wellbeing.",
    orgImpact: ["Supports employee wellbeing and stress management", "Encourages creativity and innovative thinking", "Promotes mindfulness and emotional awareness", "Strengthens team connection through collaborative activities", "Boosts morale and engagement", "Creates a positive and relaxed workplace environment", "Encourages a culture of creativity and self-expression"],
    whoFor: ["Employees", "Corporate Teams", "HR & L&D Teams", "Managers", "Leadership Teams", "Creative Teams", "Startups", "Schools & Colleges", "Corporate Offsites", "Employee Engagement Programs", "Workplace Wellness Events"],
  },
  {
    slug: "digital-detox",
    title: "Digital Detox",
    titleLead: "Digital",
    accent: "Detox",
    subtitle: "A practical session that helps teams build a healthier relationship with technology, manage screen time and reclaim focus and presence.",
    images: {
      ...MEDITATION.images,
      hero: "https://customer-assets-m6fa6gv7.emergentagent.net/job_human-connection-hub/artifacts/0xyf5vup_Digital-Detox-1.jpg",
      space: "https://customer-assets-m6fa6gv7.emergentagent.net/job_human-connection-hub/artifacts/isojyx09_Digital-Detox-2.jpg",
    },
    overview: ["A practical wellness session designed to help participants build a healthier relationship with technology, manage excessive screen time and create mindful digital habits. It helps employees disconnect from digital distractions, recharge mentally and improve focus, presence and work-life balance."],
    techniques: ["Digital habit & screen-time awareness", "Mindful technology use", "Notification & distraction management", "Screen-free breaks", "Digital boundaries for work and personal time", "Mindful breathing & grounding exercises", "Focus and attention-building practices", "Phone-free mindful activities", "Healthy email & messaging habits", "Creating a personalized digital wellbeing routine"],
    tagline: "Disconnect to Reconnect.",
    helps: "Helps participants become more aware of their digital habits, reduce unnecessary distractions and create intentional screen-time boundaries — supporting better focus, mental relaxation, presence and work-life balance.",
    orgImpact: ["Improves focus and attention at work", "Reduces digital distractions and information overload", "Supports employee wellbeing and stress management", "Encourages healthier work-life boundaries", "Promotes mindful communication and technology use", "Supports productivity and sustainable performance", "Builds a culture of digital wellbeing"],
    whoFor: ["Employees", "Corporate Teams", "HR & L&D Teams", "Managers", "Leadership Teams", "Digital & IT Professionals", "Startups", "Remote & Hybrid Teams", "Students", "Corporate Wellness Programs"],
  },
  {
    slug: "breathwork",
    title: "Breathwork",
    titleLead: "",
    accent: "Breathwork",
    subtitle: "A guided session using conscious breathing techniques to manage stress, relax the mind and improve focus and emotional wellbeing.",
    images: {
      ...MEDITATION.images,
      hero: "https://customer-assets-m6fa6gv7.emergentagent.net/job_human-connection-hub/artifacts/ggrjjhag_Breathwork-1.jpg",
      space: "https://customer-assets-m6fa6gv7.emergentagent.net/job_human-connection-hub/artifacts/fpexmmfd_Breathwork-2.jpg",
    },
    overview: ["A guided wellness session that uses conscious breathing techniques to help participants manage stress, relax the mind and improve focus and emotional wellbeing. Participants learn simple breathing practices that can be integrated into daily routines and the workplace."],
    techniques: ["Deep breathing exercises", "Diaphragmatic breathing", "Box breathing", "Alternate nostril breathing", "Breath awareness practices", "Stress-relief breathing techniques", "Mindful breathing", "Guided relaxation", "Grounding through breath", "Short workplace breathing practices"],
    tagline: "Breathe In Calm. Breathe Out Stress.",
    helps: "Helps participants use intentional breathing to create moments of calm, reduce perceived stress, improve mental clarity and develop greater awareness of their body and emotions.",
    orgImpact: ["Supports workplace stress management", "Promotes employee wellbeing and relaxation", "Enhances focus, mental clarity and presence", "Helps employees manage everyday workplace pressure", "Encourages healthier self-care practices", "Supports a calmer and more positive work environment", "Strengthens the organization's workplace wellness culture"],
    whoFor: ["Employees", "Corporate Teams", "HR & L&D Teams", "Managers", "Leadership Teams", "High-Pressure Professionals", "Remote & Hybrid Teams", "Startups", "Schools & Colleges", "Corporate Wellness Programs"],
  },
  {
    slug: "mudra-healing",
    title: "Mudra Healing",
    titleLead: "Mudra",
    accent: "Healing",
    subtitle: "An experiential session introducing Mudras — mindful hand gestures combined with breath and meditation for balance and focus.",
    images: {
      ...MEDITATION.images,
      hero: "https://customer-assets-m6fa6gv7.emergentagent.net/job_human-connection-hub/artifacts/fudic9wf_Mudra%20-%201.jpg",
      space: "https://customer-assets-m6fa6gv7.emergentagent.net/job_human-connection-hub/artifacts/kg3j0tox_Mudra-2.jpg",
    },
    overview: ["An experiential wellness session introducing participants to the ancient practice of Mudras — hand gestures traditionally used alongside yoga and meditation. The session combines mindful hand positions, breathing and meditation to encourage relaxation, focus, self-awareness and a sense of inner balance."],
    techniques: ["Introduction to traditional Mudras", "Gyan Mudra for mindful awareness", "Prana Mudra for energising practices", "Anjali Mudra for mindful connection", "Apana Mudra for grounding practices", "Chin Mudra for meditation", "Mudra-based breathing exercises", "Guided meditation with Mudras", "Mindfulness & body awareness", "Simple Mudras for everyday practice"],
    tagline: "Connect. Balance. Rejuvenate.",
    helps: "Encourages mindfulness, relaxation and focused breathing while helping participants develop greater body awareness and create a simple, calming self-care practice that can be incorporated into everyday life.",
    orgImpact: ["Supports employee wellbeing and stress management", "Encourages mindfulness and relaxation at work", "Improves focus and present-moment awareness", "Provides a simple workplace wellness practice", "Promotes healthy self-care habits", "Supports a calmer and more balanced work environment", "Adds a unique holistic wellness experience to employee engagement programs"],
    whoFor: ["Employees", "Corporate Teams", "HR & L&D Teams", "Managers", "Leadership Teams", "Wellness Enthusiasts", "Schools & Colleges", "Startups", "Corporate Offsites", "Employee Wellness Programs"],
  },
];

export const PROGRAMS = Object.fromEntries(
  CW_DATA.map((p) => [p.slug, { ...SHARED, category: "Corporate Wellbeing", ...p }])
);

// Maps a nav sub-item label to its inner-page route (others scroll to a section).
export const PROGRAM_ROUTES = {
  ...Object.fromEntries(CW_DATA.map((p) => [p.title, `/programs/${p.slug}`])),
  "Our Story": "/programs/our-story",
  "Our Founder": "/programs/our-founder",
};

export const NAV_LINKS = [
  { label: "Why Us", href: "#why" },
  { label: "Solutions", href: "#solutions" },
  { label: "Experiences", href: "#featured" },
  { label: "Impact", href: "#impact" },
];

// Full mega-menu navigation. Inner items scroll to the most relevant homepage
// section (inner pages are not built yet — homepage-only scope).
export const NAV_MENU = [
  {
    label: "ABOUT US",
    href: "#story",
    tag: "The people & purpose behind 25+ years of human connection.",
    items: ["Our Story", "Our Founder", "Careers"],
  },
  {
    label: "CORPORATE WELLBEING",
    href: "#solutions",
    tag: "Preventive health & mindfulness experiences for teams.",
    items: ["Meditation & Mindfulness", "Yoga & Pranayama", "Breathwork", "Stress Management", "Art Therapy", "Mudra Healing", "Laughter & Hug Sessions", "Digital Detox", "Medicine-Free Life"],
  },
  {
    label: "TEAM & CULTURE",
    href: "#solutions",
    tag: "Experiential learning that builds trust and belonging.",
    items: ["Team Building", "Collaborative Games", "Communication & Connection", "Diversity & Inclusion Awareness"],
  },
  {
    label: "PERSONAL WELLBEING",
    href: "#solutions",
    tag: "Deep inner work for emotional healing and clarity.",
    items: ["Biodecoding", "Inner Child Healing", "Past Life Regression", "Emotional Healing"],
  },
  {
    label: "EXPERIENCES",
    href: "#featured",
    tag: "Signature, unforgettable transformational experiences.",
    items: ["Wellness Retreats", "Sound Healing", "Dance & Movement Therapy", "Breathwork Experiences", "Ice Bath Experiences", "Fire Walk Experiences", "Meditation Experiences"],
  },
  {
    label: "KIDS & FAMILY",
    href: "#featured",
    tag: "Playful wellbeing programs for young minds & families.",
    items: ["Art Therapy", "Creative Movement & Dance", "Life Skills", "Digital Detox", "Play-Based Experiences"],
  },
  {
    label: "RESOURCES",
    href: "#impact",
    tag: "Stories, proof and perspectives from our work.",
    items: ["Blogs", "Videos", "Case Studies", "Testimonials", "Upcoming Events", "Media & Press", "Client Logos"],
  },
  {
    label: "CONTACT / BOOK AN EXPERIENCE",
    shortLabel: "BOOK AN EXPERIENCE",
    href: "#contact",
    cta: true,
    tag: "Let's design an experience for your people.",
    items: ["Enquire Now", "Corporate Enquiry", "Individual Enquiry", "Retreat Enquiry", "Workshop Enquiry"],
  },
];

// ---------- HOMEPAGE + FOOTER content defaults (CMS-editable via /api/homepage) ----------
export const HOME_DEFAULTS = {
  hero: {
    badge: "Corporate Wellness & Experiential Learning",
    headline: [
      { text: "Building Emotionally", grad: false },
      { text: "Healthy, Resilient &", grad: false },
      { text: "High-Performing", grad: false },
      { text: "Workplaces", grad: true },
    ],
    subheadline: "Experiential wellness and learning experiences designed to strengthen people, teams and organizations.",
    ctaPrimary: { label: "Explore Corporate Programs", href: "#solutions" },
    ctaSecondary: { label: "Talk to Us", href: "#contact" },
    credibility: CREDIBILITY,
    slides: [
      { src: IMAGES.hero, label: "Corporate Workshop", place: "In-house Program" },
      { src: REAL.crowdSelfie, label: "Team Wellbeing", place: "Employee Engagement" },
      { src: REAL.nupurSpeaker, label: "Keynote — Nupur Pittie", place: "Leadership Session" },
      { src: REAL.anandHandshake, label: "Recognised Across Industry", place: "Guest of Honour" },
    ],
  },
  brand: {
    eyebrow: "Our Story",
    headingLead: "20 Years of Creating",
    headingAccent: "Human Connection",
    body: "Founded by Nupur Pittie, Jadoo Ki Jhappy has spent 20+ years and 500+ programs redefining what wellbeing means at work. We blend corporate wellness with experiential learning to nurture emotional wellbeing, deepen team development and rebuild genuine human connection. Our work moves beyond talks and slides — people feel, participate and transform. From boardrooms to shop floors, we help organizations become healthier, more resilient and more human, one unforgettable experience at a time.",
    cta: "Discover Our Story",
    statValue: "500+",
    statLabel: "Programs delivered",
    image: IMAGES.nupur,
    image2: REAL.anandHandshake,
  },
  impact: {
    eyebrow: "Proven Impact",
    headingLead: "Two decades of measurable",
    headingAccent: "human change",
    stats: IMPACT_STATS,
  },
  why: {
    eyebrow: "Why This Matters",
    headingLead: "Today's Workplace Needs More Than",
    headingAccent: "Productivity.",
    cards: WHY_CARDS,
    tagline: "Healthy organizations are built by healthy, connected people.",
  },
  marquee: ["Emotional Wellbeing", "Resilience", "Human Connection", "Team Development", "Experiential Learning", "Transformation"],
  solutions: {
    eyebrow: "Our Solutions",
    headingLead: "Experiences Designed",
    headingAccent: "Around Your People",
    intro: "19 signature workshops, thoughtfully grouped into four outcome-driven pathways for your organization.",
    categories: SOLUTIONS.map((c) => ({
      index: c.index, title: c.title, desc: c.desc, image: c.image,
      programs: c.programs, linkLabel: "Explore Programs", linkHref: "#featured",
    })),
  },
  featured: {
    eyebrow: "Featured Experiences",
    headingLead: "Flagship programs that",
    headingAccent: "people never forget",
    items: FEATURED.map((p) => ({
      name: p.name, tag: p.tag, desc: p.desc, duration: p.duration, image: p.image,
      learnLabel: "Learn More", learnHref: "#contact",
    })),
  },
  footer: {
    eyebrow: "Let's Build Healthier Workplaces",
    headingLead: "Ready to transform",
    headingAccent: "your people?",
    ctaPrimary: { label: "Talk to Us", href: "mailto:hello@jadookijhappi.com" },
    ctaSecondary: { label: "Schedule a Call", href: "tel:+910000000000" },
    brandName: "Building H2O People",
    about: "Corporate wellness, experiential learning & human development. Building H₂O people for 20+ years.",
    exploreTitle: "Explore",
    links: NAV_LINKS,
    reachTitle: "Reach Us",
    email: "hello@jadookijhappi.com",
    phone: "+91 73500 43500",
    whatsapp: "919673200001",
    location: "Pune, India",
    tagline: "Building H₂O People",
    wordmark: "Building H2O People",
  },
};
